<script>
    import {createEventDispatcher} from 'svelte';
    import NavigateTooltip from "../pre-comps/Elements/NavigateTooltip.svelte";

    export let sceneCount = 10;
    export let currentScene = 1;

    const dispatch = createEventDispatcher();

    function emitNext() {
        dispatch('next');
    }

    function emitPrevious() {
        dispatch('previous');
    }

    function emitHome() {
        dispatch('home');
    }

</script>


<div class="button-container">
    <button on:click={emitPrevious} class="previous" disabled={currentScene === 0}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.86 36.53" class="arrow">
            <title>Go to previous scene</title>
            <polyline class="arrow-shape-polyline" points="20.56 2.3 4.6 18.27 20.56 34.23"/>
        </svg>
    </button>
    <div class="step-indicator">
        <div class="step-indicator-inner" style={`width: ${currentScene / (sceneCount - 1) * 100}%`}></div>
    </div>

    {#if currentScene === sceneCount - 1}
    <button on:click={emitHome} class="home">
        <img src="images/home.png" alt="Restart" class="home-icon">
    </button>
    {:else }
        <button on:click={emitNext} class="next">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.86 36.53" class="arrow" overflow="visible">
                <title>Go to next scene</title>
                <polyline class="arrow-shape-polyline right-polyline" class:pulse-orange={currentScene === 3} points="2.3 34.23 18.27 18.27 2.3 2.3"/>
            </svg>
        </button>
    {/if}

    <div class="navigate-tooltip">
        <NavigateTooltip />
    </div>
</div>


<style>


    @keyframes pulseWhite {
        0% {
            transform: scale(1);
        }

        10% {
            transform: scale(1.3);
        }

        50% {
            transform: scale(1);
        }

        100% {
            transform: scale(1);
        }
    }

    @keyframes pulseOrrange {
        0% {
            transform: scale(1);
        }

        10% {
            transform: scale(1.3);
            stroke: #FF8833;
        }

        50% {
            transform: scale(1);
            stroke: #FF8833;
        }

        100% {
            transform: scale(1);
        }
    }

    .arrow-shape-polyline {
        fill: none;
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 6.5px;
    }

    button:not(:disabled) .right-polyline {
        transform-origin: center center;
        animation: pulseWhite 2s linear infinite;
    }

    .pulse-orange {
        animation: pulseOrrange 2s linear infinite;
    }

    .home {
        padding: 0 2rem;
        width: 77px
    }

    .home-icon {
        width: 22px;
    }

    .home:hover {
        filter: invert(40%) sepia(70%) saturate(1696%) hue-rotate(336deg) brightness(103%) contrast(101%);
    }

    button:not(:disabled):hover .arrow-shape-polyline {
        stroke: #FF8833;
    }

    .arrow {
        height: 20px;
        width: auto;
    }

    .button-container {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 400px;
        margin: 0 auto;
    }

    .navigate-tooltip {
        position: absolute;
        right: -74px;
        top: -31px;
        pointer-events: none;
        z-index: -1;
    }

    @media screen and (max-width: 850px) {
        .button-container {
            max-width: 300px;
        }
    }

    .step-indicator {
        position: relative;
        width: 200px;
        height: 3px;
        border-radius: 10px;
        background-color: black;
    }

    .step-indicator-inner {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        border-radius: 10px;
        background-color: white;
    }

    button {
        display: inline-block;
        border: none;
        padding: 1rem 2rem;
        margin: 0;
        text-decoration: none;
        background: none;
        color: #ffffff;
        font-family: Metric, sans-serif;
        font-size: 1rem;
        cursor: pointer;
        text-align: center;
        transition: background 250ms ease-in-out,
        transform 150ms ease;
        -webkit-appearance: none;
        -moz-appearance: none;
    }

    button:hover,
    button:focus {
        background: none;
    }

    button:focus {
        outline: none;
        outline-offset: -4px;
    }

    button:active:not(:disabled) {
        transform: scale(0.9);
    }

    button:disabled {
        opacity: 0.6;
        cursor: default;
    }

</style>